/** `/chargebox/`: the location's charge boxes/connectors, fetched once the location record resolves. */
const CHARGEBOX_RESPONSE = { connectorData: [] };

export { CHARGEBOX_RESPONSE };
